import { render } from "./GantiSandiView.vue?vue&type=template&id=d61d697a"
import script from "./GantiSandiView.vue?vue&type=script&lang=js"
export * from "./GantiSandiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__